<template>
    <div>
        <div class="row q-col-gutter-lg">
            <div class="col-6">
                <div class="row q-col-gutter-sm">
                    <div class="col-12">
                        <q-item class="q-mb-sm card-shadow bg-white">
                            <q-item-section avatar class="q-ma-md">
                                <q-avatar rounded size="100px">
                                    <img :src="user.profile_photo" v-if="user.profile_photo">
                                    <q-icon name="fa fa-user" color="primary" text-color="white" v-else/>
                                    <q-badge color="negative" rounded floating v-if="user.is_blocked">Blocked</q-badge>
                                </q-avatar>
                            </q-item-section>

                            <q-item-section>

                                <q-item-label class="text-h6 q-mb-xs">
                                    <q-icon size="24px" name="fa fa-building" v-if="user.account_type === 'business'"/>
                                    <q-icon size="24px" :color="gender.color" :name="gender.icon" v-else-if="gender"/>
                                    {{ user.first_name }} {{ user.middle_name }} {{ user.last_name }}
                                </q-item-label>
                                <q-item-label class="text-body1 q-mb-xs" v-if="user.country">
                                    <q-icon size="24px" :name="user.country.acronym" v-if="user.country"/>
                                    {{ user.country.name }}
                                </q-item-label>
                                <q-item-label class="text-body1" v-if="user.client_code">
                                    <q-btn
                                        round
                                        flat
                                        color="primary"
                                        icon="far fa-copy"
                                        @success="copied('Payment code copied!')"
                                        v-clipboard="user.client_code"
                                        dense
                                    />
                                    {{ user.client_code }}
                                </q-item-label>
                            </q-item-section>

                            <q-item-section side top>
                                <q-item-label>

                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Avatar and Name -->
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Email:</q-item-label>
                                <q-item-label class="text-body1">
                                    <q-icon color="light-green" name="fa fa-check" v-if="user.is_email_verified === 'verified'"/>
                                    <q-icon color="orange" name="fa fa-hourglass" v-else/>
                                    {{ user.email }}
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Email -->
                    <div class="col-6" v-if="user.mobile">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Mobile:</q-item-label>
                                <q-item-label class="text-body1">+{{ user.calling_code }}{{ user.mobile }}
                                </q-item-label>
                            </q-item-section>

                            <q-item-section side>
                                <div class="q-gutter-xs">
                                    <q-btn
                                        round
                                        flat
                                        size="sm"
                                        color="input-color"
                                        icon="far fa-copy"
                                        @success="copied('Mobile copied!')"
                                        v-clipboard="'+'+user.calling_code+user.mobile"
                                        dense
                                    />&nbsp;
                                    <q-btn flat round dense size="sm" color="info" icon="fab fa-telegram"
                                           @click.native="openURL('https://t.me/+'+ user.calling_code + user.mobile)"/>&nbsp;
                                    <q-btn flat round dense size="sm" color="green" icon="fab fa-whatsapp"
                                           @click.native="openURL('https://wa.me/'+ user.calling_code + user.mobile)"/>
                                </div>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Mobile -->
                    <div class="col-12">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Address: ({{user.address_age}} {{ user.address_age > 1 ? 'days' : 'day' }})</q-item-label>
                                <q-item-label class="text-body1">{{ user.address }}</q-item-label>
                            </q-item-section>
                            <q-item-section side>

                            </q-item-section>
                        </q-item>
                    </div> <!-- Address -->
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Date of birth:</q-item-label>
                                <q-item-label class="text-body1">{{ user.date_of_birth }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Date of birth -->
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Introducer:</q-item-label>
                                <q-item-label class="text-body1">
                                    <div v-if="user.introducer">
                                        {{user.introducer.name}}
                                        <q-btn icon="fa fa-link" size="xs" color="info" round flat @click="$router.push('/users?q=' + user.introducer.email)" v-if="$auth.can('users.list')"/>
                                    </div>
                                    <div v-else>-</div>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Introducer -->
                </div>
            </div>
            <div class="col-6">
                <div class="row q-col-gutter-sm">
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Identification status:</q-item-label>
                                <q-item-label class="text-body1"><q-icon :name="identification_status.icon" :color="identification_status.color" /> {{ identification_status.label }}</q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <q-btn flat round size="sm" color="primary" icon="far fa-folder-open"
                                       @click.native="openURL('https://mail.google.com/mail/u/0/#search/' + user.email)">
                                    <q-tooltip>
                                        Find documents in KYC inbox
                                    </q-tooltip>
                                </q-btn>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Identification status -->
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>ECDD:</q-item-label>
                                <q-item-label class="text-body1">{{ user.ecdd ? 'True' : 'False' }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- ECDD -->
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Registered at:</q-item-label>
                                <q-item-label class="text-body1">{{ user.created_at }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Registered at -->
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Last login:</q-item-label>
                                <q-item-label class="text-body1">{{ user.last_login_at }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Last Login -->
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Blocked:</q-item-label>
                                <q-item-label class="text-body1">{{ user.is_blocked ? 'True' : 'False' }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Block -->
                    <div class="col-6">
                        <q-item class="bg-white">
                            <q-item-section>
                                <q-item-label caption>Last used IP:</q-item-label>
                                <q-item-label class="text-body1">{{ user.last_used_ip }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </div> <!-- Last used ip -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {openURL} from 'quasar'
import AddressProofDialog from "../../components/AddressProofDialog.vue"

export default {
    name: "UserInfo",
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    computed: {
        gender() {
            return this.genders.find(gender => gender.value === this.user.gender)
        },
        identification_status() {
            return this.identityStates.find(status => status.name === this.user.currentIdentityStatus.name)
        }
    },
    data() {
        return {
            genders: [
                {value: 'M', icon: 'fa fa-male', color: 'blue'},
                {value: 'F', icon: 'fa fa-female', color: 'pink'},
                {value: 'O', icon: 'fa fa-genderless', color: 'purple'},
            ],
            identityStates: [
                {name:'none', label: 'New', icon: 'fa fa-user', color: 'grey'},
                {name:'verified', label: 'Verified', icon: 'fa fa-check', color: 'positive'},
                {name:'failed', label: 'Failed', icon: 'fa fa-times', color: 'red'},
                {name:'reviewed', label: 'In Review', icon: 'fa fa-street-view', color: 'black'},
                {name:'rejected', label: 'Rejected', icon: 'fa fa-times', color: 'red'},
                {name:'hold', label: 'Hold', icon: 'fa fa-circle-pause', color: 'primary'},
            ],
        }
    },
    methods: {
        openURL,
        copied(message) {
            this.$q.notify({
                message: message,
                position: 'top'
            })
        },
    },
    created() {
    },
    mounted() {},
    watch: {},
    components: {AddressProofDialog},
}
</script>
<style>

</style>
